import { render, staticRenderFns } from "./UiBooleanList.vue?vue&type=template&id=461e4d13&"
import script from "./UiBooleanList.vue?vue&type=script&lang=js&"
export * from "./UiBooleanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports